import React from 'react';
import AdminCancellationPayments from '../components/AdminCancellationPayments';

const AdminPaymentsPage: React.FC = () => (
  <AdminCancellationPayments />
);

export default AdminPaymentsPage;
